import Vue from 'vue'
import VueRouter from 'vue-router'
import * as AmplifyModules from 'aws-amplify'
import Amplify, { API } from 'aws-amplify'
import { AmplifyPlugin, AmplifyEventBus } from 'aws-amplify-vue'
import store from '../store'
import awsconfig from '../aws-exports.js'

Amplify.configure(awsconfig)
Vue.use(VueRouter)
Vue.use(AmplifyPlugin, AmplifyModules)

import Nebiki from '../views/Nebiki.vue'
import Scan from '../views/Scan.vue'
import Setting from '../views/Setting.vue'

const routes = [
  {
    path: '/',
    redirect: '/nebiki'
  },
  {
    path: '/nebiki',
    name: 'Nebiki',
    component: Nebiki
  },
  {
    path: '/scan',
    name: 'Scan',
    component: Scan
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Setting
  },
  {
    path: '*',
    redirect: '/nebiki'
  }
]

let cognitoUser

function getUser () {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      store.commit('auth/login', data)
      return data
    }
  }).catch(() => {
    store.commit('auth/logout')
    return null
  })
}

function getRedirectUrl () {
  const url = window.location.search
  const hash = url.slice(1).split('&')
  for (var i = 0; i < hash.length; i++) {
    const array = hash[i].split('=')
    if (array[0] === 'redirect') {
      return unescape(array[1])
    }
  }
  return '/'
}

AmplifyEventBus.$on('authState', async (state) => {
  if (state === 'signedOut') {
    // logout
    cognitoUser = null
    store.commit('auth/logout')
    window.location = `${process.env.VUE_APP_COMMON_APP_URL}/login?redirect=${location.href}`
  } else if (state === 'signedIn') {
    // login
    cognitoUser = await getUser()
    router.push({ path: getRedirectUrl() })
  }
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // base: '~t-okuno/test-sato-printer/',
  routes
})

// 画面遷移時に呼び出される
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => !record.meta.isPublic)) {
    // 認証が必要なページ
    cognitoUser = await getUser()
    if (!cognitoUser) {
      if ("".length == 0) {
        await initialize()
        next()
        return
      }

      // ポータルに遷移
      window.location = `${process.env.VUE_APP_COMMON_APP_URL}/login?redirect=${location.href}`
    } else {
      if (!store.state.header.user) {
        await initialize()
      }

      next()
    }
  } else {
    next()
  }
})

/**
 * 画面初期化処理
 */
async function initialize () {
  store.commit('setLoading', true)

  // ログインユーザー情報取得
  // const user = await getData('common', '/me')
  // store.commit('header/setUser', user)
  store.commit('header/setUser', {})

  // 製品一覧・店舗一覧取得
  // const processes = [
  //   getData('common', '/my_application', { type: 'webapp' }),
  //   getData('common', `/company/${user.company_cd}/store`)
  // ]
  // const results = await Promise.all(processes).catch(e => apiError(e))
  // store.commit('header/setAppList', results[0].list)
  // store.commit('header/setStoreList', results[1].list)

  store.commit('setLoading', false)
}

/**
 * GET APIを呼び出す
 * @param {string} apiName API名
 * @param {string} path APIのパス
 * @param {Dict} data 送信データ
 * @returns APIの戻り値
 */
async function getData (apiName, path, data = {}) {
  const opt = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': store.state.auth.user.signInUserSession.idToken.jwtToken
    },
    response: true,
    queryStringParameters: data
  }

  const response = await API.get(apiName, path, opt).catch(e => apiError(e))
  return response.data.result
}

getData

/**
 * API呼び出し後のエラーを処理する
 * @param {Object} e エラー
 */
function apiError (e) {
  console.log(e)
  store.commit('setLoading', false)

  if ((e.toString() === 'Error: Network Error') || (e.response && e.response.status === 401)) {
    store.commit('error/setNetworkErrorModalShow', true)
  } else if (e.response && e.response.status === 403) {
    store.commit('error/setAuthErrorModalShow', true)
  } else {
    const error = e.response.data.error
    error.status = e.response.status
    store.commit('error/setCommonErrorModalShow', error)
  }
}

export default router
